import React from 'react'
import styled from "styled-components"
import { InputBase, IconButton } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { fetchNewsData } from "../Redux/searchedData/action"
import { useDispatch, useSelector } from "react-redux"
import { AppContext } from "./../ContextProvider/AppContextProvider"
import axios from 'axios';

const  Wrapper = styled.div`
`
const useStyles = makeStyles((theme) => ({
    root: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: 655,
      height: 46,      
      '& input::placeholder' :{
        fontSize: '23px',
        fontWeight: '100',
      },
     
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
      fontSize:'35px',
      fontWeight:'700',
      '&:hover':{borderBottom: '1px solid #ddd',}
    },
  
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
  }));

const Search = ({ types, sort, page}) => {
 
    const [query, setQuery ] =React.useState("")
    const classes = useStyles();
    const { data, setData, isLoading, setIsLoading, isError, setIsError } = React.useContext(AppContext)
    const v = process.env.REACT_APP_NEWSFEED_API
    

    React.useEffect(()=>{
      if(data.length>0)
      {
        axios.get(`https://api.nytimes.com/svc/search/v2/articlesearch.json?dropmab=false&q=${query}&page=${page}&fq=source:("The New York Times")&api-key=${v}&types=${types}&sort=${sort}`)
        .then((response)=> {
          console.log(response)
            setData([...data,...response.data.response.docs])
            setIsLoading(false)    
        })
        .catch(()=> {
          setIsLoading(false)
          setIsError(true)
        })

      }
    }, [page])


    const handleSubmit =(e)=>{
      e.preventDefault();
      setIsLoading(true)
      if(query !=="")
      {
        axios.get(`https://api.nytimes.com/svc/search/v2/articlesearch.json?dropmab=false&q=${query}&page=${page}&fq=source:("The New York Times")&api-key=${v}&types=${types}&sort=${sort}`)
        .then((response)=> {
          console.log(response)
            setData([...response.data.response.docs])
            setIsLoading(false)    
        })
        .catch(()=> {
          setIsLoading(false)
          setIsError(true)
        })
      }
      else{
        alert("Type something in search panel")
        setIsLoading(false)
      }
      
    }
    return (
        <>
          <div component="form" className={classes.root}>
            <InputBase  className={classes.input}  placeholder="Search The New York Times"   inputProps={{ 'aria-label': 'Search The New York Times' }}
           value={query} onChange={ (e)=> setQuery(e.target.value) }
            />
    
            <IconButton onClick={ handleSubmit } className={classes.iconButton} aria-label="search">
                <SearchIcon style={{color:'black'}} />
            </IconButton>
          </div>
        </>
    )
}

export { Search }
